









































































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Tenant, TenantUser, BusinessHour } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import {
  createUser,
  updateUser,
  updatePassword,
  deleteUser
} from "@/stores/userUtil";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";
import { ShopCategoryType } from "@/models/tenant";
import randomString from "@/common/randomString";

const db = firebaseProject.firestore();
const userCollection = new Collection(
  db.collection("tenantUser") as firestore.CollectionReference<TenantUser>
);
const tenantCollection = new Collection(
  db.collection("tenant") as firestore.CollectionReference<Tenant>
);
const tenantCollectionForCheck = new Collection(
  db.collection("tenant") as firestore.CollectionReference<Tenant>
);

export default shopBase.extend(Vue).extend({
  name: "TenantDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker },
  created() {
    this.tenantId = this.$route.params.id;
    if (this.tenantId) {
      const tenantUserCollection = new Collection(
        db.collection("tenantUser") as firestore.CollectionReference<TenantUser>
      ).query({
        filter: {
          tenantId: { $eq: this.tenantId }
        }
      });
      tenantUserCollection?.ref.get().then(snapshot => {
        if (snapshot.size > 0) {
          const uid = snapshot.docs[0].id;
          this._tenantUser = this.userCollection.doc(uid, { noListen: true });
          this._tenantUser.ref?.get().then(snapshot => {
            this.userName = snapshot.data()?.userName || "";
            this.phoneNumber = snapshot.data()?.phoneNumber || "";
            this.email = snapshot.data()?.email || "";
          });
        }
      });
      this.document.ref?.get().then(snapshot => {
        const tenantData = snapshot.data();
        this.shopCategoryType = tenantData?.shopCategoryType;
      });
      this.isNew = false;
    } else {
      this.$router.push("/tenant");
    }
  },
  data(): {
    authentication: object;
    transitionName: string;
    password: string;
    confirmPassword: string;
    userName: string;
    phoneNumber: string;
    email: string;
    _tenantUser: Document<TenantUser> | undefined;
    tenantId: string | null;
    shopCategoryType: ShopCategoryType | undefined;
    isNew: boolean;
  } {
    return {
      authentication,
      transitionName: "",
      password: "",
      confirmPassword: "",
      userName: "",
      phoneNumber: "",
      email: "",
      _tenantUser: undefined,
      tenantId: null,
      shopCategoryType: undefined,
      isNew: false
    };
  },
  computed: {
    pageTitle(): string {
      return this.$route.params.id ? "同友店詳細" : "同友店新規登録";
    },
    tenants(): Collection<Tenant> {
      return tenantCollection;
    },
    tenantsForCheck(): Collection<Tenant> {
      return tenantCollectionForCheck;
    },
    document(): Document<Tenant> {
      return this.tenants.doc(this.tenantId, { noListen: true });
    },
    basepath(): string {
      return "tenant/" + this.tenantId + "/";
    },
    userCollection(): Collection<TenantUser> {
      return userCollection;
    },
    tenantUser(): Document<TenantUser> | undefined {
      return this._tenantUser;
    },
    businessHour(): BusinessHour {
      if (this.document?.effective.businessHour) {
        return this.document.effective?.businessHour;
      }
      return { from: "", to: "" };
    },
    businessHourFrom: {
      get(): string {
        return this.businessHour.from;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHour = this.businessHour;
          this.document.effective.businessHour.from = value;
        }
      }
    },
    businessHourTo: {
      get(): string {
        return this.businessHour.to;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHour = this.businessHour;
          this.document.effective.businessHour.to = value;
        }
      }
    },
    businessHourBusinessDay(): BusinessHour {
      if (this.document?.effective.businessHourBusinessDay) {
        return this.document.effective.businessHourBusinessDay;
      }
      return { from: "", to: "" };
    },
    businessHourBusinessDayFrom: {
      get(): string {
        return this.businessHourBusinessDay.from;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHourBusinessDay = this.businessHourBusinessDay;
          this.document.effective.businessHourBusinessDay.from = value;
        }
      }
    },
    businessHourBusinessDayTo: {
      get(): string {
        return this.businessHourBusinessDay.to;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHourBusinessDay = this.businessHourBusinessDay;
          this.document.effective.businessHourBusinessDay.to = value;
        }
      }
    },
    businessHourHoliday(): BusinessHour {
      if (this.document?.effective.businessHourHoliday) {
        return this.document.effective.businessHourHoliday;
      }
      return { from: "", to: "" };
    },
    businessHourHolidayFrom: {
      get(): string {
        return this.businessHourHoliday.from;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHourHoliday = this.businessHourHoliday;
          this.document.effective.businessHourHoliday.from = value;
        }
      }
    },
    businessHourHolidayTo: {
      get(): string {
        return this.businessHourHoliday.to;
      },
      set(value: string) {
        if (this.document) {
          this.document.effective.businessHourHoliday = this.businessHourHoliday;
          this.document.effective.businessHourHoliday.to = value;
        }
      }
    },
    isDetailHP(): boolean {
      return (
        (this.shop?.data?.shopApiUrl ? true : false) &&
        (this.document.effective.shopno ? true : false)
      );
    }
  },
  methods: {
    async validateTTCode() {
      const ttcode = String(this.document.effective.ttcode);
      if (!ttcode || ttcode.length == 0) return true;
      const documentId = this.$route.params.id;
      const checkTTSnapshot = await db
        .collection("tenant")
        .where("ttcode", "==", ttcode)
        .where("shopId", "==", this.shopId)
        .get();
      if (documentId) {
        return (
          checkTTSnapshot.docs.filter(item => {
            return item?.id != documentId;
          }).length == 0
        );
      } else {
        return checkTTSnapshot.docs.length == 0;
      }
    },
    async validateRegino() {
      const regino = String(this.document.effective.regino);
      if (!regino || regino.length == 0) return true;
      const documentId = this.$route.params.id;
      const checkTTSnapshot = await db
        .collection("tenant")
        .where("regino", "==", regino)
        .where("shopId", "==", this.shopId)
        .get();
      if (documentId) {
        return (
          checkTTSnapshot.docs.filter(item => {
            return item?.id != documentId;
          }).length == 0
        );
      } else {
        return checkTTSnapshot.docs.length == 0;
      }
    },
    async validateShopno() {
      const shopno = String(this.document.effective.shopno);
      if (!shopno || shopno.length == 0) return true;
      const documentId = this.$route.params.id;
      const checkTTSnapshot = await db
        .collection("tenant")
        .where("shopno", "==", shopno)
        .where("shopId", "==", this.shopId)
        .get();
      if (documentId) {
        return (
          checkTTSnapshot.docs.filter(item => {
            return item?.id != documentId;
          }).length == 0
        );
      } else {
        return checkTTSnapshot.docs.length == 0;
      }
    },
    async register() {
      if (this.document.effective.shopCategoryType != this.shopCategoryType) {
        this.document.effective.shopCategoryType = this.shopCategoryType;
      }
      const checkResult2 = await this.validateRegino();
      if (!checkResult2) {
        alert({
          title: "エラー",
          text: "レジNo.が重複しています"
        });
        return;
      }
      const checkResult3 = await this.validateShopno();
      if (!checkResult3) {
        alert({
          title: "エラー",
          text: "公式サイトショップ番号が重複しています"
        });
        return;
      }
      const newId = randomString(5);
      let loginEmail = "";
      if (this.isNew) {
        loginEmail = `${newId}@a-town-app.com`.toLowerCase();
      } else {
        loginEmail =
          this._tenantUser?.data?.email ||
          `${newId}@a-town-app.com`.toLowerCase();
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return;
      }
      this.document.effective.shopId = this.shopId;
      console.log(`loginEmail: ${loginEmail}`);
      if (!this.businessHour.from && !this.businessHour?.to) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).document.effective.businessHour = firestore.FieldValue.delete();
      }
      if (
        !this.businessHourBusinessDay?.from &&
        !this.businessHourBusinessDay?.to
      ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).document.effective.businessHourBusinessDay = firestore.FieldValue.delete();
      }
      if (!this.businessHourHoliday?.from && !this.businessHourHoliday?.to) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).document.effective.businessHourHoliday = firestore.FieldValue.delete();
      }

      //来店予約が有効になってない場合、有料来店予約も無効にする
      if (!this.document.effective.reservationEnabled) {
        this.document.effective.paidReservationEnabled = false;
      }

      console.log(`isNew: ${this.isNew}`);
      if (this.isNew) {
        this.document.effective.shopId = this.shopId;
        const saveResult = await this.document.save().catch(err => {
          alert({
            title: "エラー",
            text: "同友店情報の保存に失敗しました。"
          });
        });
        if (saveResult && saveResult.newId) {
          const newTenantId = saveResult.newId;
          const createUserResult = await createUser({
            email: loginEmail,
            userName: this.userName,
            phoneNumber: this.phoneNumber,
            password: this.password,
            tenantId: newTenantId,
            shopId: this.shopId
          }).catch(error => {
            alert({
              title: "エラー",
              text: "担当者アカウントの作成に失敗しました。"
            });
          });
          if (createUserResult && createUserResult.success) {
            this.$router.push("/tenant");
          }
        }
      } else {
        let saved = false;
        if (this.document.canSave) {
          const result = await this.document.save().catch(err => {
            alert({
              title: "エラー",
              text: "同友店情報の保存に失敗しました。"
            });
          });
          if (result) saved = true;
        }
        console.log(`loginEmail: ${loginEmail}`);
        if (saved || !this.document.canSave) {
          const uid = this.tenantUser?.id;
          if (uid && this.tenantUser) {
            this.tenantUser.effective.userName = this.userName;
            this.tenantUser.effective.phoneNumber = this.phoneNumber;
            this.tenantUser.effective.email = loginEmail;
            if (this.tenantUser?.canSave) {
              const updateUserInfoResult = await updateUser(uid, {
                email: loginEmail,
                userName: this.userName,
                phoneNumber: this.phoneNumber,
                tenantId: this.document.id,
                shopId: this.shopId
              }).catch(e => {
                alert({
                  title: "エラー",
                  text: "担当者アカウントの更新に失敗しました。"
                });
              });
              if (updateUserInfoResult && updateUserInfoResult.success) {
                saved = true;
              }
            }
            if (saved || !this.tenantUser.canSave) {
              if (this.password) {
                const updatePasswordResult = await updatePassword(
                  uid,
                  this.password
                ).catch(e => {
                  alert({
                    title: "エラー",
                    text: "パスワードの更新に失敗しました。"
                  });
                });
                if (updatePasswordResult) {
                  this.$router.push("/tenant");
                }
              } else {
                if (saved || !this.tenantUser?.canSave) {
                  this.$router.push("/tenant");
                }
              }
            }
          } else {
            const newTenantId = this.document.id;
            const newId = randomString(5);
            const loginEmail = `${newId}@a-town-app.com`.toLowerCase();
            const createUserResult = await createUser({
              email: loginEmail,
              userName: this.userName,
              phoneNumber: this.phoneNumber,
              password: this.password,
              tenantId: newTenantId,
              shopId: this.shopId
            }).catch(error => {
              alert({
                title: "エラー",
                text: "担当者アカウントの作成に失敗しました。"
              });
            });
            if (createUserResult && createUserResult.success) {
              this.$router.push("/tenant");
            }
          }
        }
      }
    },
    async deleteTenant() {
      const result1 = await confirm({
        title: "確認",
        text: "同友店を削除します。この操作は取り消せません。\nよろしいですか？"
      });
      if (result1) {
        if (this.tenantUser) {
          const uid = this.tenantUser.id;
          let canContinue = false;
          if (uid) {
            try {
              const deleteUserResult = await deleteUser(uid);
              if (!deleteUserResult.success) {
                if (deleteUserResult.error != "user not found.") {
                  alert({
                    title: "エラー",
                    text: "同友店ユーザーの削除に失敗しました。"
                  });
                  canContinue = false;
                  return;
                }
              }
            } catch (e) {
              console.log(e);
            }
            const result = await this.document.remove(true).catch(error => {
              alert({
                title: "エラー",
                text: "同友店の削除に失敗しました。"
              });
              return;
            });
            this.$router.push("/tenant");
          }
        }
      }
    },
    selectImage() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    async uploadFile(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".jpg";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/jpeg";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(downloadURL => {
                    if (this.document.effective.image == undefined) {
                      this.document.effective.image = [];
                    }
                    const url = _path;
                    this.document.effective.image = [_path];
                  })
                  .catch(error => {
                    console.log(error);
                  });
              },
              {
                maxWidth: 600,
                maxHeight: 600,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    }
  }
});
